import i18n from "../../locales/index"
import { genBasicStore } from "../vuex"

const store = genBasicStore("shop")

export default store
